<template>
  <div>
    <v-menu
        content-class="elevation-0"
        v-model="display"
        :max-width="dialogWidth"
        :min-width="dialogWidth"
        left
        offset-x
        :close-on-content-click="false"
        transition="scale-transition"

    >
      <template v-slot:activator="{ on }">
        <v-text-field
            v-bind="textFieldProps"
            :disabled="disabled"
            :label="vt.label"
            hint="yyyy-mm-dd hh:mm"
            v-model="model"
            v-on="on"
            dense
            outlined
            clearable
            append-icon="mdi-calendar"
            @click:clear="vt.filter=null"
        >
          <template v-slot:progress>
            <slot name="progress">
              <v-progress-linear color="primary" indeterminate absolute height="2"></v-progress-linear>
            </slot>
          </template>
        </v-text-field>
      </template>

      <v-card  outlined>
        <v-card-text class="px-0 py-0">
          <v-tabs fixed-tabs v-model="activeTab">
            <v-tab key="calendar">
              <slot name="dateIcon">
                <v-icon>mdi-calendar-today</v-icon>
              </slot>
            </v-tab>
            <v-tab key="timer" :disabled="dateSelected">
              <slot name="timeIcon">
                <v-icon>mdi-update</v-icon>
              </slot>
            </v-tab>
            <v-tab-item key="calendar" style="height:330px">
              <v-date-picker
                  v-model="date"
                  v-bind="datePickerProps"
                  @input="showTimePicker"
                  full-width
                  no-title
              ></v-date-picker>
            </v-tab-item>
            <v-tab-item key="timer" style="height:330px">
              <v-time-picker
                  ref="timer"
                  v-model="time"
                  v-bind="timePickerProps"
                  format="24hr"
                  full-width
              ></v-time-picker>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="actions" :parent="this">
            <v-btn  small style="text-transform: none" text @click.native="clearHandler">{{ clearText }}</v-btn>
            <v-btn  small style="text-transform: none" color="primary" @click="okHandler">{{
                okText
              }}
            </v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

const DEFAULT_DATE = ''
const DEFAULT_TIME = '00:00:00'
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
const DEFAULT_DIALOG_WIDTH = 340
const DEFAULT_CLEAR_TEXT = 'Wróć'
const DEFAULT_OK_TEXT = 'Zapisz'
import {format, parse} from 'date-fns'

export default {
  name: "DateAndTimePicker",
  model: {
    prop: 'datetime',
    event: 'input'
  },
  props: {
    vt: {
      type: Object,
    },
    datetime: {
      type: [Date, String],
      default: null
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    dialogWidth: {
      type: Number,
      default: DEFAULT_DIALOG_WIDTH
    },
    dateFormat: {
      type: String,
      default: DEFAULT_DATE_FORMAT
    },
    timeFormat: {
      type: String,
      default: 'HH:mm'
    },
    clearText: {
      type: String,
      default: DEFAULT_CLEAR_TEXT
    },
    okText: {
      type: String,
      default: DEFAULT_OK_TEXT
    },
    textFieldProps: {
      type: Object
    },
    datePickerProps: {
      type: Object
    },
    timePickerProps: {
      type: Object
    }
  },
  data() {
    return {
      model: null,
      display: false,
      activeTab: 0,
      date: DEFAULT_DATE,
      time: DEFAULT_TIME,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    dateTimeFormat() {
      return this.dateFormat + ' ' + this.timeFormat
    },
    defaultDateTimeFormat() {
      return DEFAULT_DATE_FORMAT + ' ' + DEFAULT_TIME_FORMAT
    },
    formattedDatetime() {
      const t = this.selectedDatetime ? format(this.selectedDatetime, this.dateTimeFormat) : ''
      return t
    },
    selectedDatetime() {
      if (this.date && this.time) {
        let datetimeString = this.date + ' ' + this.time
        if (this.time.length === 5) {
          datetimeString += ':00'
        }
        return parse(datetimeString, this.defaultDateTimeFormat, new Date())
      } else {
        return null
      }
    },
    dateSelected() {
      return !this.date
    }
  },
  methods: {
    init() {
      if (!this.datetime) {
        return
      }
      let initDateTime
      if (this.datetime instanceof Date) {
        initDateTime = this.datetime
      } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
        initDateTime = parse(this.datetime, this.dateTimeFormat, new Date())
      }
      this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
      this.time = format(initDateTime, DEFAULT_TIME_FORMAT)
    },
    okHandler() {
      this.model = this.formattedDatetime
      this.vt.filter = new Date(this.formattedDatetime).toISOString()
      this.resetPicker()
      this.$emit('input', this.selectedDatetime)
    },
    clearHandler() {
      this.resetPicker()
      this.date = DEFAULT_DATE
      this.time = DEFAULT_TIME
      this.$emit('input', null)
    },
    resetPicker() {
      this.display = false
      this.activeTab = 0
      if (this.$refs.timer) {
        this.$refs.timer.selectingHour = true
      }
    },
    showTimePicker() {
      this.activeTab = 1
    },
  },
  watch: {
    datetime: function () {
      this.init()
    },
    "model": function (){
      if(this.model) {
        if(this.model.trim().length === 16){
          this.vt.filter = new Date(this.model).toISOString()
        }
      } else {
        this.vt.filter = null
      }
    },
    "vt.filter"(){
      if(this.vt.filter == null){
        this.model = null
      }
    }
  },
}
</script>

<style scoped lang="css">
>>> .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}

>>> .v-picker__title {
  padding: 5px 5px !important;
}

>>> .v-picker__title__btn {
  height: 30px !important;
  font-size: 30px !important;
}

>>> .v-time-picker-title__time span {
  height: 30px !important;
  font-size: 30px !important;
}


</style>
